import React, { useCallback, useEffect, useMemo, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const TIP_LABEL = {
  DENEME_1AY: 'Deneme 1. Ay',
  DENEME_1_5AY: 'Deneme 1,5 Ay',
  DENEME_2AY: 'Deneme 2. Ay',
  DOGUM_GUNU: 'Doğum Günü',
};

const DURUM_LABEL = {
  BEKLIYOR: 'Bekliyor',
  GORULDU: 'Görüldü',
  TAMAMLANDI: 'Tamamlandı',
  YOKSAYILDI: 'Yok Sayıldı',
};

const authHeaders = () => ({
  'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
  'Content-Type': 'application/json',
});

const tarihTR = (value) => {
  if (!value) return '-';
  const [y, m, d] = value.slice(0, 10).split('-');
  return `${d}.${m}.${y}`;
};

const gunFarki = (value) => {
  if (!value) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(`${value.slice(0, 10)}T00:00:00`);
  return Math.round((target - today) / 86400000);
};

const IkHatirlatmalarPage = () => {
  const [rows, setRows] = useState([]);
  const [ozet, setOzet] = useState({ bekleyen: 0, gecikmis: 0, bu_hafta: 0 });
  const [durum, setDurum] = useState('BEKLIYOR');
  const [tip, setTip] = useState('');
  const [zaman, setZaman] = useState('TUMU');
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams();
      if (durum) params.set('durum', durum);
      if (tip) params.set('tip', tip);
      params.set('limit', '500');

      const [listRes, ozetRes] = await Promise.all([
        fetch(`${API_URL}/api/hr/bildirimler?${params.toString()}`, { headers: authHeaders() }),
        fetch(`${API_URL}/api/hr/bildirimler/ozet`, { headers: authHeaders() }),
      ]);

      if (!listRes.ok) throw new Error(`Bildirimler alınamadı (${listRes.status})`);
      if (!ozetRes.ok) throw new Error(`Özet alınamadı (${ozetRes.status})`);

      setRows(await listRes.json());
      setOzet(await ozetRes.json());
    } catch (e) {
      setError(e.message || 'Bildirimler yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, [durum, tip]);

  useEffect(() => { load(); }, [load]);

  const visibleRows = useMemo(() => {
    if (zaman === 'TUMU') return rows;
    return rows.filter((r) => {
      const fark = gunFarki(r.vade_tarihi);
      if (fark === null) return false;
      if (zaman === 'GECIKMIS') return fark < 0;
      if (zaman === 'BU_HAFTA') return fark >= 0 && fark < 7;
      return true;
    });
  }, [rows, zaman]);

  const updateStatus = async (id, yeniDurum) => {
    setSavingId(id);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/hr/bildirimler/${id}`, {
        method: 'PATCH',
        headers: authHeaders(),
        body: JSON.stringify({ durum: yeniDurum }),
      });
      if (!res.ok) {
        let detail = '';
        try { detail = (await res.json()).detail || ''; } catch (_) {}
        throw new Error(detail || `İşlem başarısız (${res.status})`);
      }
      await load();
      // Sidebar rozeti aynı endpoint'i periyodik okuyor; ayrıca diğer bileşenlere haber ver.
      window.dispatchEvent(new Event('hr-bildirimler-degisti'));
    } catch (e) {
      setError(e.message || 'Bildirim güncellenemedi');
    } finally {
      setSavingId(null);
    }
  };

  const durumClass = (r) => {
    const fark = gunFarki(r.vade_tarihi);
    if (r.durum !== 'BEKLIYOR') return 'normal';
    if (fark !== null && fark < 0) return 'late';
    if (fark !== null && fark < 7) return 'soon';
    return 'normal';
  };

  return (
    <div className="ik-hatirlatmalar-page">
      <style>{`
        .ik-hatirlatmalar-page { padding: 20px; color: #333; }
        .ik-hat-grid { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; margin-bottom:14px; }
        .ik-hat-card { background:#fff; border:1px solid #e5e7eb; border-radius:10px; padding:14px 16px; box-shadow:0 1px 3px rgba(0,0,0,.04); }
        .ik-hat-card small { display:block; color:#777; font-size:11px; text-transform:uppercase; margin-bottom:6px; }
        .ik-hat-card strong { font-size:24px; }
        .ik-hat-toolbar { display:flex; gap:10px; flex-wrap:wrap; align-items:center; background:#fff; padding:12px; border-radius:10px; border:1px solid #e5e7eb; margin-bottom:14px; }
        .ik-hat-toolbar select, .ik-hat-toolbar button { min-height:38px; border:1px solid #d8dde5; border-radius:6px; padding:0 10px; background:#fff; }
        .ik-hat-toolbar button { cursor:pointer; }
        .ik-hat-toolbar .active { background:#2567c8; color:#fff; border-color:#2567c8; }
        .ik-hat-table-wrap { background:#fff; border:1px solid #e5e7eb; border-radius:10px; overflow:auto; }
        .ik-hat-table { width:100%; border-collapse:collapse; min-width:900px; }
        .ik-hat-table th { text-align:left; padding:11px 10px; font-size:12px; background:#f6f7f9; border-bottom:1px solid #ddd; }
        .ik-hat-table td { padding:11px 10px; border-bottom:1px solid #eee; vertical-align:top; font-size:13px; }
        .ik-hat-table tr.late { background:#fff6f6; }
        .ik-hat-table tr.soon { background:#fffaf0; }
        .ik-hat-person { font-weight:700; }
        .ik-hat-msg { color:#666; margin-top:3px; }
        .ik-hat-badge { display:inline-block; border-radius:999px; padding:4px 8px; font-size:11px; font-weight:700; background:#eef2f7; }
        .ik-hat-actions { display:flex; gap:6px; white-space:nowrap; }
        .ik-hat-actions button { border:0; border-radius:5px; padding:7px 9px; cursor:pointer; }
        .ik-hat-done { background:#e5f6e9; color:#19743a; }
        .ik-hat-ignore { background:#f7e9e9; color:#a52b2b; }
        .ik-hat-error { background:#fff0f0; color:#a52222; padding:10px 12px; border-radius:7px; margin-bottom:12px; }
        .ik-hat-empty { padding:32px; text-align:center; color:#777; }
        @media (max-width: 700px) {
          .ik-hatirlatmalar-page { padding:10px; }
          .ik-hat-grid { grid-template-columns:1fr; gap:8px; }
          .ik-hat-card { display:flex; align-items:center; justify-content:space-between; padding:10px 12px; }
          .ik-hat-card small { margin:0; }
          .ik-hat-card strong { font-size:20px; }
          .ik-hat-toolbar { align-items:stretch; }
          .ik-hat-toolbar select, .ik-hat-toolbar button { flex:1 1 45%; min-width:0; }
          .ik-hat-table-wrap { border:0; background:transparent; overflow:visible; }
          .ik-hat-table { min-width:0; display:block; }
          .ik-hat-table thead { display:none; }
          .ik-hat-table tbody, .ik-hat-table tr, .ik-hat-table td { display:block; width:100%; box-sizing:border-box; }
          .ik-hat-table tr { background:#fff !important; border:1px solid #e5e7eb; border-left:4px solid #9aa4b2; border-radius:9px; margin-bottom:9px; padding:10px; }
          .ik-hat-table tr.late { border-left-color:#d93636; }
          .ik-hat-table tr.soon { border-left-color:#e6a400; }
          .ik-hat-table td { border:0; padding:4px 0; }
          .ik-hat-table td[data-label]::before { content:attr(data-label) ': '; font-weight:700; color:#777; }
          .ik-hat-actions { padding-top:8px; }
          .ik-hat-actions button { flex:1; min-height:38px; }
        }
      `}</style>

      <div className="ik-hat-grid">
        <div className="ik-hat-card"><small>Bekleyen</small><strong>{ozet.bekleyen || 0}</strong></div>
        <div className="ik-hat-card"><small>Gecikmiş</small><strong>{ozet.gecikmis || 0}</strong></div>
        <div className="ik-hat-card"><small>Bu Hafta</small><strong>{ozet.bu_hafta || 0}</strong></div>
      </div>

      <div className="ik-hat-toolbar">
        <select value={durum} onChange={(e) => setDurum(e.target.value)}>
          <option value="BEKLIYOR">Bekleyen</option>
          <option value="GORULDU">Görüldü</option>
          <option value="TAMAMLANDI">Tamamlanan</option>
          <option value="YOKSAYILDI">Yok Sayılan</option>
          <option value="">Tüm Durumlar</option>
        </select>
        <select value={tip} onChange={(e) => setTip(e.target.value)}>
          <option value="">Tüm Tipler</option>
          <option value="DENEME_1AY">Deneme 1. Ay</option>
          <option value="DENEME_1_5AY">Deneme 1,5 Ay</option>
          <option value="DENEME_2AY">Deneme 2. Ay</option>
          <option value="DOGUM_GUNU">Doğum Günü</option>
        </select>
        <button className={zaman === 'TUMU' ? 'active' : ''} onClick={() => setZaman('TUMU')}>Tümü</button>
        <button className={zaman === 'GECIKMIS' ? 'active' : ''} onClick={() => setZaman('GECIKMIS')}>Gecikmiş</button>
        <button className={zaman === 'BU_HAFTA' ? 'active' : ''} onClick={() => setZaman('BU_HAFTA')}>Bu Hafta</button>
        <button onClick={load}>↻ Yenile</button>
      </div>

      {error && <div className="ik-hat-error">{error}</div>}

      <div className="ik-hat-table-wrap">
        {loading ? (
          <div className="ik-hat-empty">Yükleniyor...</div>
        ) : visibleRows.length === 0 ? (
          <div className="ik-hat-empty">Bu filtreye uygun İK hatırlatması yok.</div>
        ) : (
          <table className="ik-hat-table">
            <thead>
              <tr>
                <th>Personel</th><th>Hatırlatma</th><th>Tip</th><th>Vade</th><th>Durum</th><th>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {visibleRows.map((r) => (
                <tr key={r.id} className={durumClass(r)}>
                  <td data-label="Personel"><span className="ik-hat-person">{r.personel_ad || '-'}</span></td>
                  <td data-label="Hatırlatma">
                    <div>{r.baslik || '-'}</div>
                    {r.mesaj && <div className="ik-hat-msg">{r.mesaj}</div>}
                  </td>
                  <td data-label="Tip">{TIP_LABEL[r.tip] || r.tip || '-'}</td>
                  <td data-label="Vade">{tarihTR(r.vade_tarihi)}</td>
                  <td data-label="Durum"><span className="ik-hat-badge">{DURUM_LABEL[r.durum] || r.durum}</span></td>
                  <td>
                    <div className="ik-hat-actions">
                      {r.durum !== 'TAMAMLANDI' && (
                        <button className="ik-hat-done" disabled={savingId === r.id} onClick={() => updateStatus(r.id, 'TAMAMLANDI')}>✓ Tamamla</button>
                      )}
                      {r.durum !== 'YOKSAYILDI' && (
                        <button className="ik-hat-ignore" disabled={savingId === r.id} onClick={() => updateStatus(r.id, 'YOKSAYILDI')}>× Yok Say</button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default IkHatirlatmalarPage;
